import { mainColors, SelectField, Size, SNormal } from '@avantstay/backoffice-core'

import { SendsFilter } from '../../StayTimeline.types'
import * as S from './AutoSendsFilter.styles'

const SENDS_FILTER_OPTIONS: Array<{ value: SendsFilter; label: string }> = [
  { value: 'hide', label: 'Hide' },
  { value: 'mainGuest', label: 'Main guest' },
  { value: 'all', label: 'All' },
]

interface AutoSendsFilterProps {
  value: SendsFilter
  onChange: (sendsFilter: SendsFilter) => void
}

export const AutoSendsFilter = ({ value, onChange }: AutoSendsFilterProps) => (
  <S.Root>
    <SNormal color={mainColors.black}>Auto messages</SNormal>

    <S.Select>
      <SelectField.Default
        isSearchable={false}
        size={Size.Small}
        options={SENDS_FILTER_OPTIONS}
        value={SENDS_FILTER_OPTIONS.find(option => option.value === value)}
        onChange={option => onChange(option.value)}
      />
    </S.Select>
  </S.Root>
)
